import { eventsApiBaseUrl } from "../config/eventsApi";

/** The scoring app that hosts the public scoreboards. */
export const SCOREBOARD_APP_URL = "https://app.smymchennai.in";

const FETCH_TIMEOUT_MS = 6000;

/** Keep only well-formed { slug, title } rows from GET /api/public/shooting. */
export function publishedTournaments(data) {
  if (!data || data.ok !== true || !Array.isArray(data.tournaments)) return [];
  return data.tournaments
    .filter(
      (row) =>
        row &&
        typeof row.slug === "string" &&
        /^[a-z0-9-]+$/.test(row.slug) &&
        typeof row.title === "string" &&
        row.title.trim(),
    )
    .map((row) => ({ slug: row.slug, title: row.title.trim() }));
}

/**
 * The home page's Live button for the published tournaments, or null when none are published.
 * One: straight to its board. Several: the /scoreboard list.
 */
export function liveScoresButton(tournaments) {
  if (!Array.isArray(tournaments) || tournaments.length === 0) return null;
  if (tournaments.length === 1) {
    const [only] = tournaments;
    return {
      href: `${SCOREBOARD_APP_URL}/scoreboard/${only.slug}`,
      label: `Live: ${only.title} Scores`,
    };
  }
  return {
    href: `${SCOREBOARD_APP_URL}/scoreboard`,
    label: `Live Scores: ${tournaments.length} tournaments`,
  };
}

/** Published tournaments from the API; [] on any failure, so the page just shows its usual buttons. */
export async function fetchPublishedTournaments({ signal } = {}) {
  const base = eventsApiBaseUrl();
  if (!base) return [];
  const ctrl = new AbortController();
  const timer = setTimeout(() => ctrl.abort(), FETCH_TIMEOUT_MS);
  const onAbort = () => ctrl.abort();
  signal?.addEventListener("abort", onAbort);
  try {
    const res = await fetch(`${base}/api/public/shooting`, {
      signal: ctrl.signal,
      headers: { Accept: "application/json" },
    });
    if (!res.ok) return [];
    return publishedTournaments(JSON.parse(await res.text()));
  } catch {
    return [];
  } finally {
    clearTimeout(timer);
    signal?.removeEventListener("abort", onAbort);
  }
}
